import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import { getCommunityStatistic, getPlaceDisplay } from "@/api/placeService";
import lodash from "lodash";

export interface CountyCommunityMapState {
  communityData: object[];
  loading: boolean;
  request_time: number;
}

@Module({ store, dynamic: true, name: "countyCommunityMapModule" })
class CountyCommunityMapModule extends VuexModule implements CountyCommunityMapState{
  public request_time: number = null;
  public communityData: object[] = [];
  public loading = false;
  public temp = [];
  public posData = {};

  @Action({ rawError: true }) async fetchPosData() {
    try {
      const res = await getPlaceDisplay(); 
      const data = res.data;
      console.log("posData is Real Post Data")
      console.log(data)
      this.setPosData(data);
      return Object.keys(data);
    } catch (e) {
      console.error("Failed to fetch position data", e);
    }
  }

  @Action({ rawError: true }) async getCommunity(communityList: string[]) {
    this.setLoading(true);
    this.setRequestTime(null);
    const res: object = await getCommunityStatistic(communityList);
    const rawdata: object = res['data'] 
    console.log(rawdata)
    this.setRequestTime(res['request_time']);
    const data = [];
    for(const [key, value] of Object.entries(rawdata)){
      if (Object.prototype.hasOwnProperty.call(this.posData, key)) {
          const coords = this.posData[key];
          // 合併座標物件和 API 數據物件
          data.push({...coords, ...value}); 
      }
    }
    this.setcommunityData(data);
    console.log(data);
    this.setLoading(false);
  }

  @Mutation setLoading(loading: boolean): void {
    this.loading = loading;
  }

  @Mutation setcommunityData(communityData: object[]): void {
    this.communityData = lodash.cloneDeep(communityData);
  }

  @Mutation setRequestTime(request_time: number): void {
    this.request_time = request_time;
  }

  @Mutation setPosData(data): void {
    this.posData = data;
  }
}

export const countyCommunityMapModule = getModule(CountyCommunityMapModule);